;(function (angular) {
  'use strict'

  angular
    .module('kilo.config')
    .constant('shortcuts', [
      {
        combo: ['t', 'T'],
        description: 'Afficher le tableau de bord',
        state: 'dashboard'
      },
      {
        combo: ['f', 'F'],
        description: 'Afficher la liste des Factures',
        state: 'invoice.list'
      },
      {
        combo: ['d', 'D'],
        description: 'Afficher la liste des devis',
        state: 'quote.list'
      },
      {
        combo: ['c', 'C'],
        description: "Afficher l'annuaire",
        state: 'entity.list'
      },
      {
        combo: ['n', 'N'],
        description: 'Créer une nouvelle facture',
        state: 'invoice.new'
      },
      {
        combo: ['p', 'P'],
        description: 'Afficher la liste des produits',
        state: 'product.list'
      },
      {
        combo: ['o', 'O'],
        description: 'Afficher la liste des packs produits',
        state: 'product-pack.list'
      },
      {
        combo: ['a', 'A'],
        description: 'Afficher la liste des avoirs',
        state: 'creditnote.list'
      },
      {
        combo: ['b', 'B'],
        description: 'Afficher la boite aux lettres',
        state: 'inbox.list'
      },
      {
        combo: ['m', 'M'],
        description: 'Créer un nouveau devis',
        state: 'quote.new'
      },
      {
        combo: ['r', 'R'],
        description: 'Afficher les préférences',
        state: 'preferences'
      },
      {
        combo: ['b', 'B'],
        description: 'Afficher les BPU',
        state: 'bpu.list'
      },
      {
        combo: ['s', 'S'],
        description: 'Afficher les sous-traitants',
        state: 'subcontractor.list'
      }
    ])
})(window.angular)
